import { Product, ServiceStatus, ServiceStatusInfo } from '../types';

const REPURCHASABLE_STATUSES = [
  ServiceStatus.Purchased,
  ServiceStatus.TestingCompleted,
];

export const getCurrentServiceStatusInfo = (
  product: Product,
  serviceStatusInfos: ServiceStatusInfo[] = []
): ServiceStatusInfo | undefined => {
  const productInfos = serviceStatusInfos.filter(
    (info) => info.product.id === product.id
  );
  const inFlightInfo = productInfos.find(
    (info) => !REPURCHASABLE_STATUSES.includes(info.status)
  );

  return inFlightInfo ?? productInfos[0];
};
